import React from 'react'
import OptionsMenu from '../../utils/OptionsMenu'
import userPermissions from '../User/Permissions'
import Settings from './Pages/settings-page'
import Monitor from './Pages/monitor-page'

import ScoutLogo from "../../assets/images/kwik-scout-logo.png"
import ContentUnavailable from "../ContentUnavailable"
import { useMenu } from "../../contexts/MenuContext"
import { getSession } from "../../auth"
import useModuleAccess from "../../utils/useModuleAccess"

const options = () => {
    const groups = userPermissions();

    return {
        settings: {
            permissions: groups.isAdmin,
            label: 'Configurações',
            component: (<Settings/>)
        },
        monitor: {
            permissions: groups.isAdmin,
            label: 'Monitoria',
            component: (<Monitor/>)
        }
    }
}

const Scout = () => {
    const { configurableUrls } = useMenu()
    useModuleAccess("scout")

    if (! getSession().profile?.enterprise?.scout && ! getSession().profile?.scout === true) {
        return (
            <ContentUnavailable 
                icon={<img src={ScoutLogo} alt="Kwik Scout" style={{ width: 350 }} />}
                title={
                    !getSession().profile?.enterprise?.scout
                        ? "Recurso indisponível para sua conta."
                        : "Recurso indisponível para seu usuário."
                }
                description={
                    !getSession().profile?.enterprise?.scout
                        ? (
                            <a
                                href={configurableUrls?.scout ? configurableUrls.scout : "https://scout.kwik.app.br/"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Para mais informações sobre o Kwik Scout, clique aqui.
                            </a>
                        )
                        : (
                            <span>
                                Entre em contato com seu administrador para ativar.
                            </span>
                        )
                }
            />
        )
    }

    return (
        <Monitor/>
    )
}

export default Scout